import { any } from 'prop-types';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

import Button from '@UI/button/Button';
import type { EditAsideCurriculumSelector } from '@nodeTypeConfig/configTypes';
import { patchThemes } from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useInitialValue } from '../../../hooks/UseInitialValue';
import AsideCurriculumSelectorModal from './AsideCurriculumSelectorModal';

const AsideCurriculumSelector: React.FC<{
  config: EditAsideCurriculumSelector;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const editHref = useEditHref();
  const initialValue = useInitialValue(config.property) || [];

  const openCurriculumSelectorModal = async () => {
    setIsModalOpen(true);
  };

  const submitCurriculumSelectorModal = (data) => {
    if (data) {
      const dataHref = data.map((o) => o.href);
      dispatch(patchThemes(getResourceKey(editHref), dataHref));
    }
    setIsModalOpen(false);
  };

  return (
    <div>
      <span className="input-group">
        <span className="input-group-btn">
          <Button
            icon="glyphicon-add"
            onClick={() => openCurriculumSelectorModal()}
            disabled={readonly}
          >
            Leerplanthema&apos;s selecteren
          </Button>
        </span>
      </span>

      {isModalOpen && (
        <AsideCurriculumSelectorModal
          handleSubmit={submitCurriculumSelectorModal}
          handleClose={() => setIsModalOpen(false)}
          selectedThemes={initialValue}
        />
      )}
    </div>
  );
};

AsideCurriculumSelector.displayName = 'AsideCurriculumSelector';

AsideCurriculumSelector.propTypes = {
  config: any,
  readonly: any,
};

export default AsideCurriculumSelector;
